import React, { Component } from 'react';
import { Spin, Card, Divider, Popover } from 'antd';
import QRCode from 'qrcode.react';
import { app, config } from '../app';
import PropTypes from 'prop-types';
import newsHead from '../assets/news-head.png';
import newsBottom from '../assets/news-bottom.png';
import 'braft-editor/dist/output.css';

class NewsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  render() {
    let { loading, data, review } = this.props;
    return loading ? (<div style={{ textAlign: 'center' }}><Spin size="large" /></div>) : (
      <div style={{ padding: '0 20px' }}>
        <h2 style={{ textAlign: 'center' }}>{data.news_title}</h2>
        <div style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}>
          {
            data.recommend_before ? (
              <span
                style={{ marginRight: '1rem' }}>推荐级别: {data.recommend_before + (data.recommend_after ? ` -> ${data.recommend_after}` : '')}</span>
            ) : null
          }
          {/*<span>发布级别: {data.object_name}</span>*/}
          <span style={{ margin: '0 1rem' }}>发布对象: {data.object}</span>
          <span>发布人: {data.vname}</span>
          <span style={{ marginLeft: '1rem' }} hidden={!data.release_time}>发布日期: {data.release_time}</span>
          <span style={{ marginLeft: '1rem' }} hidden={!data.create_time}>提交日期: {data.create_time}</span>
          {/*{*/}
          {/*  data.id ? (*/}
          {/*    <Popover placement="right" content={<QRCode value={config.shareDoman + data.id} />} title="手机扫码分享"*/}
          {/*      overlayStyle={{ textAlign: 'center', zIndex: 9999 }}>*/}
          {/*      <span style={{ marginLeft: '1rem' }}>*/}
          {/*        <i className="iconfont icon-fenxiang" style={{ fontSize: 14 }} />*/}
          {/*        <span style={{ padding: '0 4px', cursor: 'pointer' }}>分享</span>*/}
          {/*      </span>*/}
          {/*    </Popover>*/}
          {/*  ) : null*/}
          {/*}*/}
        </div>
        <div style={{ maxWidth: 1190, margin: '0 auto', padding: '20px 0' }}>
          {/*<img src={newsHead} style={{ maxWidth: '100%', width: 'auto', height: 'auto' }} alt="" />*/}
          <div className="braft-output-content" dangerouslySetInnerHTML={{ __html: data.news_content }}
            style={{ padding: '20px 0' }} />
          {/*<img src={newsBottom} style={{ maxWidth: '100%', width: 'auto', height: 'auto' }} alt="" />*/}
        </div>
        {review ? (<Divider orientation="left">审核状态</Divider>) : null}
        {
          review ? (
            <div style={{ width: '40%' }}>
              <Card
                type="inner"
                title="一级审核"
                style={{ marginBottom: 20 }}
              >
                {
                  data.one_audit !== '0' ? (
                    <span>
                      <div>审核人: {data.one_indexno}</div>
                      <div>审核状态: {data.one_audit === '1' ? '已通过' : (data.one_audit === '2' ? '不通过' : '未审核')}</div>
                      <div>审核时间: {data.one_time}</div>
                      {data.one_audit === '2' ? (<div>不通过原因: {data.detail}</div>) : null}
                    </span>
                  ) : (<span>未审核</span>)
                }
              </Card>
              {
                data.object_type === '1' ? (
                  <span>
                    <Card
                      type="inner"
                      title="二级审核"
                      style={{ marginBottom: 20 }}
                    >
                      {
                        data.two_audit !== '0' ? (
                          <span>
                            <div>审核人: {data.two_indexno}</div>
                            <div>审核状态: {data.two_audit === '1' ? '已通过' : (data.two_audit === '2' ? '不通过' : '未审核')}</div>
                            <div>审核时间: {data.two_time}</div>
                            {data.two_audit === '2' ? (<div>不通过原因: {data.detail}</div>) : null}
                          </span>
                        ) : (<span>未审核</span>)
                      }
                    </Card>
                    <Card
                      type="inner"
                      title="三级审核"
                      style={{ marginBottom: 20 }}
                    >
                      {
                        data.three_audit !== '0' ? (
                          <span>
                            <div>审核人: {data.three_indexno}</div>
                            <div>审核状态: {data.three_audit === '1' ? '已通过' : (data.three_audit === '2' ? '不通过' : '未审核')}</div>
                            <div>审核时间: {data.three_time}</div>
                            {data.three_audit === '2' ? (<div>不通过原因: {data.detail}</div>) : null}
                          </span>
                        ) : (<span>未审核</span>)
                      }
                    </Card>
                  </span>
                ) : null
              }
            </div>
          ) : null
        }
      </div>
    );
  }
}

NewsDetail.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.any,
};

export default NewsDetail;



// WEBPACK FOOTER //
// ./src/components/NewsDetail.jsx